namespace advisorop.components.advisor {

    class AccouontPivotGridController {

        $router;
        selHousehold: domains.IHousehold;
        onHouseholdSelected: any;
        householdId: number;

        static $inject = ["advisorService", "$filter", "$rootRouter"];
        constructor(private advisorService: services.AdvisorService
            , public $filter, public $rootRouter) {
        }

        searchItems(searchTerm: string): ng.IPromise<Array<{}>> {
            return this.advisorService.searchHouseholds(searchTerm).then((response) => {
                  return response.data;
            });
        }


          onSelected(item, model, label, event): void {
            var household: domains.IHousehold = {};
            angular.copy(this.selHousehold, household);
            this.householdId = this.selHousehold.id;
           // this.resetSearch();
        };

        resetSearch(): void {
            this.selHousehold = {};
        }

        $onInit(): void {
        }

        $routerOnActivate(next, previous) {
        }
    }
 
    class AccouontPivotGrid implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                //onHouseholdSelected: "&",
                "$router": "<"
            };
            this.controller = AccouontPivotGridController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/views/account-pivot-grid.html';
        }
    }
    angular.module(Constants.APP).component("accountPivotGrid", new AccouontPivotGrid());
}